import { render, staticRenderFns } from "./GraphDetail52.vue?vue&type=template&id=2a76a0ef&scoped=true"
import script from "./GraphDetail52.vue?vue&type=script&lang=js"
export * from "./GraphDetail52.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a76a0ef",
  null
  
)

export default component.exports